module.exports = __webpack_public_path__ + "static/media/hp_07.07f0d1c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/JPEG/hp_07.jpg
// module id = 5818
// module chunks = 0